import type { OpenAPI } from "simplydo/interfaces";

export const DIMENSIONS = { SCALE: "SCALE" };

export const getCdnFile = (path: string) => {
  return `https://cdn.simplydo.co.uk/${path}`;
};

export const getImageUrl = (
  entity: any,
  fields: string | string[],
  sizes?: string | string[] | [string | number, string | number][],
  defaultUrl?: string,
) => {
  if (sizes && !Array.isArray(sizes)) {
    sizes = [sizes];
  }
  if (fields && !Array.isArray(fields)) {
    fields = [fields];
  }
  if (entity && fields) {
    for (const field of fields) {
      if (sizes) {
        if (entity[field]) {
          if (entity[field].startsWith("unsplash-")) {
            const [w, h] =
              typeof sizes[0] === "string" ? sizes[0].split("x") : sizes[0];
            return `${entity[field].slice(9)}&fit=min&w=${w}&h=${h}`;
          }
        }
        const thumbnailField = `${field}ThumbnailUrls`;
        if (entity[thumbnailField]) {
          for (const size of sizes) {
            const sizeStr =
              typeof size === "string" ? size : `${size[0]}x${size[1]}`;
            if (entity[thumbnailField][sizeStr]) {
              return entity[thumbnailField][sizeStr];
            }
          }
        }
      }
      const regularField = `${field}Url`;
      if (entity[regularField]) {
        return entity[regularField];
      }
    }
  }
  return defaultUrl ? getCdnFile(defaultUrl) : null;
};

export const getThumbnail = (entity, field, size, defaultUrl) => {
  return getImageUrl(entity, field, size, defaultUrl);
};

export const challengeProfileLogo = (profile) => {
  const logoUrl = profile?.logoUrl;
  const logo = profile?.logo;
  return logoUrl || logo || getCdnFile("images/defaults/profile-logo.png");
};

export const userAvatarUrl = (
  user: OpenAPI.Schemas["User"],
  size = "100x100",
) => {
  const avatar = user?.profile?.avatar;
  if (avatar?.match(/^[0-9]+\.png/)) {
    return getCdnFile(`images/avatars/${avatar}`);
  }
  return getThumbnail(
    user?.profile,
    "avatar",
    size,
    "images/avatars/default.png",
  );
};

export const ideaCoverImage = (
  idea?: OpenAPI.Schemas["Idea"],
  size = "200x200",
) => {
  return getThumbnail(idea, "coverImage", size, "images/idea.png");
};

export const challengeImage = (challenge?: OpenAPI.Schemas["Challenge"]) => {
  return getImageUrl(
    challenge,
    ["coverImage", "bannerImage"],
    ["300x300"],
    "images/challengeBanner.jpg",
  );
};

export const challengeBannerImage = (
  challenge?: OpenAPI.Schemas["Challenge"],
) => {
  return getImageUrl(
    challenge,
    ["bannerImage"],
    ["2560x400", "1280x200"],
    "images/challengeBanner.jpg",
  );
};

export const groupCoverImage = (
  group: OpenAPI.Schemas["Group"],
  size = "200x200",
) => {
  return getThumbnail(group, "coverImage", size, "images/groupCoverImage.png");
};

export const groupBannerImage = (group: OpenAPI.Schemas["Group"]) => {
  return getThumbnail(
    group,
    "bannerImage",
    ["2560x400", "1280x200"],
    "images/groupBanner.jpg",
  );
};
